var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { class: ["content bg-light", { expanded: !_vm.isSidebarOpen }] },
          [
            _c(
              "div",
              [
                _c(
                  "b-container",
                  { attrs: { fluid: "" } },
                  [
                    _c(
                      "div",
                      { staticClass: "content-title" },
                      [
                        _c("b-row", [_c("h1", [_vm._v("Audit Logs")])]),
                        _vm._v(" "),
                        _c("b-row", [
                          _c("span", [
                            _vm._v(
                              "Track all system changes and user activities"
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "stats" },
                      _vm._l(_vm.stats, function (stat, index) {
                        return _c(
                          "b-col",
                          {
                            key: index,
                            on: {
                              click: function ($event) {
                                stat.status != null
                                  ? _vm.selectStatus(stat.status)
                                  : ""
                              },
                            },
                          },
                          [
                            _c("div", [
                              _c("span", { style: { color: stat.color } }, [
                                _vm._v(_vm._s(stat.number)),
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(stat.title))]),
                            ]),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filters" },
                  [
                    _c(
                      "b-row",
                      { staticClass: "filters-items" },
                      [
                        _c("b-col", [
                          _c("div", { staticClass: "filter-item" }, [
                            _c("span", { staticClass: "filter-item-title" }, [
                              _vm._v("Search Logs"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              staticClass: "filter-item-content",
                              attrs: {
                                type: "text",
                                placeholder: "Search by ID, action, summary...",
                              },
                              on: {
                                input: function (event) {
                                  return (
                                    (_vm.paginationObj.search = _vm.sanitize(
                                      event.target.value
                                    )),
                                    _vm.submit()
                                  )
                                },
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.submit()
                                },
                              },
                            }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("b-col", [
                          _c(
                            "div",
                            { staticClass: "filter-item" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                },
                                [_vm._v("Entity Type")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "filter-item-content d-flex justify-content-between py-2 px-3",
                                  attrs: {
                                    id: "entity-picker-link",
                                    href: "#",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "fixed-span-size" },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            this.paginationObj.entity == null
                                              ? "All Types"
                                              : _vm.entityList.filter(function (
                                                  item
                                                ) {
                                                  if (
                                                    item ==
                                                    this$1.paginationObj.entity
                                                  ) {
                                                    return item
                                                  }
                                                })[0]
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa-light fa-chevron-down",
                                    attrs: {
                                      size: "17px",
                                      id: "action-type-chevron",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-popover",
                                {
                                  attrs: {
                                    target: "entity-picker-link",
                                    triggers: "focus",
                                    placement: "bottom",
                                    "custom-class": "popover",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    _vm._l(
                                      _vm.entityList,
                                      function (type, index) {
                                        return _c(
                                          "span",
                                          {
                                            key: index,
                                            class: [
                                              "popover-option",
                                              {
                                                "popover-option-selected":
                                                  type == "All Types"
                                                    ? _vm.paginationObj
                                                        .entity == null
                                                    : type ==
                                                      _vm.paginationObj.entity,
                                              },
                                            ],
                                            on: {
                                              click: function ($event) {
                                                return _vm.selectEntityType(
                                                  type
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(type) +
                                                "\n                    "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("b-col", [
                          _c(
                            "div",
                            { staticClass: "filter-item" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                },
                                [_vm._v("Action Type")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "filter-item-content d-flex justify-content-between py-2 px-3",
                                  attrs: {
                                    id: "action-picker-link",
                                    href: "#",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "fixed-span-size" },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            this.paginationObj.action == null
                                              ? "All Actions"
                                              : _vm.actionList.filter(function (
                                                  item
                                                ) {
                                                  if (
                                                    item ==
                                                    this$1.paginationObj.action
                                                  ) {
                                                    return item
                                                  }
                                                })[0]
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa-light fa-chevron-down",
                                    attrs: {
                                      size: "17px",
                                      id: "action-type-chevron",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-popover",
                                {
                                  attrs: {
                                    target: "action-picker-link",
                                    triggers: "focus",
                                    placement: "bottom",
                                    "custom-class": "popover",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    _vm._l(
                                      _vm.actionList,
                                      function (action, index) {
                                        return _c(
                                          "span",
                                          {
                                            key: index,
                                            class: [
                                              "popover-option",
                                              {
                                                "popover-option-selected":
                                                  action == "All Actions"
                                                    ? _vm.paginationObj
                                                        .action == null
                                                    : action ==
                                                      _vm.paginationObj.action,
                                              },
                                            ],
                                            on: {
                                              click: function ($event) {
                                                return _vm.selectActionType(
                                                  action
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(action) +
                                                "\n                    "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("b-col", [
                          _c(
                            "div",
                            { staticClass: "filter-item" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                },
                                [_vm._v("Per Page")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "filter-item-content d-flex justify-content-between py-2 px-3",
                                  attrs: {
                                    id: "pagination-picker-link",
                                    href: "#",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "fixed-span-size" },
                                    [
                                      _vm._v(
                                        _vm._s(this.paginationObj.maxResults)
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa-light fa-chevron-down",
                                    attrs: { size: "17px", id: "page-chevron" },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-popover",
                                {
                                  attrs: {
                                    target: "pagination-picker-link",
                                    triggers: "focus",
                                    placement: "bottom",
                                    "custom-class": "popover",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    _vm._l(
                                      [10, 20, 30, 40, 50],
                                      function (resultsPerPage, index) {
                                        return _c(
                                          "span",
                                          {
                                            key: index,
                                            class: [
                                              "popover-option",
                                              {
                                                "popover-option-selected":
                                                  resultsPerPage ==
                                                  _vm.paginationObj.maxResults,
                                              },
                                            ],
                                            on: {
                                              click: function ($event) {
                                                return _vm.selectPagination(
                                                  resultsPerPage
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(resultsPerPage) +
                                                "\n                    "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("b-col", { staticClass: "d-flex flex-row" }, [
                          _c(
                            "div",
                            { staticClass: "filter-item" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: {
                                    title: _vm.$t("common.date_start_label"),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t("common.date_start_label")
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("datetime-picker", {
                                staticClass: "z-1",
                                class: {
                                  "filter-item-input": true,
                                  "filter-item-input-complete": _vm.dateBegin,
                                  "error-datepicker": _vm.dateBeginError,
                                },
                                attrs: {
                                  format: "DD/MM/YYYY",
                                  customInputParentClass: "filter-item-content",
                                  maxLength: 19,
                                  placeholderValue: _vm.$t(
                                    "common.datetime_picker_empty_date"
                                  ),
                                  inputIcon: "fa-solid fa-calendar",
                                },
                                on: { input: _vm.selectBeginDate },
                                model: {
                                  value: _vm.dateBegin,
                                  callback: function ($$v) {
                                    _vm.dateBegin = $$v
                                  },
                                  expression: "dateBegin",
                                },
                              }),
                              _vm._v(" "),
                              _vm.dateBeginError
                                ? _c("span", { staticClass: "text-danger" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("errors.Data_format_invalid")
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("b-col", { staticClass: "d-flex flex-row" }, [
                          _c(
                            "div",
                            { staticClass: "filter-item" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: {
                                    title: _vm.$t("common.date_end_label"),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("common.date_end_label")) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("datetime-picker", {
                                staticClass: "z-1",
                                class: {
                                  "filter-item-input": true,
                                  "filter-item-input-complete": _vm.dateEnd,
                                  "error-datepicker": _vm.dateEndError,
                                },
                                attrs: {
                                  format: "DD/MM/YYYY",
                                  customInputParentClass: "filter-item-content",
                                  customInputClass: "w-100",
                                  maxLength: 19,
                                  placeholderValue: _vm.$t(
                                    "common.datetime_picker_empty_date"
                                  ),
                                  inputIcon: "fa-solid fa-calendar",
                                },
                                on: { input: _vm.selectEndDate },
                                model: {
                                  value: _vm.dateEnd,
                                  callback: function ($$v) {
                                    _vm.dateEnd = $$v
                                  },
                                  expression: "dateEnd",
                                },
                              }),
                              _vm._v(" "),
                              _vm.dateEndError
                                ? _c("span", { staticClass: "text-danger" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("errors.Data_format_invalid")
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          "justify-content": "space-between",
                          "padding-right": "1rem",
                        },
                      },
                      [
                        _c("b-col", [
                          _vm.totalResultsFiltered > 0
                            ? _c("span", [
                                _vm._v(
                                  "Showing " +
                                    _vm._s(_vm.paginationObj.firstIndex) +
                                    " - " +
                                    _vm._s(
                                      _vm.paginationObj.status != null ||
                                        _vm.paginationObj.search != null ||
                                        _vm.paginationObj.country != null
                                        ? _vm.totalResultsFiltered <
                                          _vm.paginationObj.maxResults
                                          ? _vm.totalResultsFiltered
                                          : _vm.currentPage *
                                            _vm.paginationObj.maxResults
                                        : _vm.totalResults <
                                          _vm.paginationObj.maxResults
                                        ? _vm.totalResults
                                        : _vm.currentPage *
                                          _vm.paginationObj.maxResults
                                    ) +
                                    " of " +
                                    _vm._s(
                                      _vm.paginationObj.status != null ||
                                        _vm.paginationObj.search != null ||
                                        _vm.paginationObj.country != null
                                        ? _vm.totalResultsFiltered
                                        : _vm.totalResults
                                    ) +
                                    "\n                "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              gap: "1rem",
                            },
                          },
                          [
                            _vm.selectedItems.length > 0
                              ? _c("span", { staticClass: "selected" }, [
                                  _vm._v(
                                    _vm._s(_vm.selectedItems.length) +
                                      " selected"
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.selectedItems.length > 0
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "clear",
                                    on: {
                                      click: function ($event) {
                                        return _vm.clearSelection()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-classic fa-xmark",
                                    }),
                                    _vm._v("Clear"),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.selectedItems.length > 0
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn-outline btn-tertiary",
                                    on: {
                                      click: function ($event) {
                                        return _vm.exportSelected()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa-classic fa-arrow-down-to-line",
                                    }),
                                    _vm._v(
                                      "Export Selected (" +
                                        _vm._s(_vm.selectedItems.length) +
                                        ")"
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn-outline button-primary",
                                on: {
                                  click: function ($event) {
                                    return _vm.exportFiltered()
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fa-classic fa-arrow-down-to-line",
                                }),
                                _vm._v("Export Filtered"),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn-outline button-primary",
                                on: {
                                  click: function ($event) {
                                    return _vm.exportAll()
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fa-classic fa-arrow-down-to-line",
                                }),
                                _vm._v("Export All"),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn-outline btn-dark",
                                on: {
                                  click: function ($event) {
                                    return _vm.refresh()
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  class: [
                                    "fa-classic",
                                    "fa-arrows-rotate",
                                    { rotate: _vm.isLoading },
                                  ],
                                }),
                                _vm._v(
                                  "\n                Refresh\n              "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.items != null
                  ? _c(
                      "div",
                      { staticClass: "card" },
                      [
                        _c("div", { staticClass: "p-6" }, [
                          _c("h2", [_vm._v("Audit Trail")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.totalResults) + " log entries"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _vm.totalResultsFiltered > 0
                          ? _c(
                              "div",
                              { staticStyle: { "overflow-x": "auto" } },
                              [
                                _c("b-table", {
                                  staticClass: "table-header-border",
                                  staticStyle: { "margin-bottom": "0" },
                                  attrs: {
                                    responsive: "",
                                    items: _vm.items,
                                    fields: _vm.fields,
                                    "primary-key": "id",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "head(checkbox)",
                                        fn: function () {
                                          return [
                                            _c(
                                              "label",
                                              {
                                                staticClass: "custom-checkbox",
                                              },
                                              [
                                                _c("input", {
                                                  attrs: {
                                                    type: "checkbox",
                                                    id: "all",
                                                    name: "checkAll",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.selectAll(
                                                        $event
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "checkmark",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "cell(checkbox)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "label",
                                              {
                                                staticClass: "custom-checkbox",
                                              },
                                              [
                                                _c("input", {
                                                  attrs: { type: "checkbox" },
                                                  domProps: {
                                                    value: data.item,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.toggleSelection(
                                                        $event,
                                                        data.item
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "checkmark",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(date)",
                                        fn: function (data) {
                                          return [
                                            data.item.CreationDate != ""
                                              ? _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.isoToDDMMYYYY(
                                                        data.item.CreationDate
                                                      )
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            data.item.CreationDate !== ""
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#6a7282",
                                                      "font-size": "0.9rem",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        new Date(
                                                          Date.parse(
                                                            data.item
                                                              .CreationDate
                                                          )
                                                        ).toLocaleTimeString(
                                                          "it-IT"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _c("span", [_vm._v("—")]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(status)",
                                        fn: function (data) {
                                          return [
                                            data.item.Status == 0
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn-tertiary-full",
                                                    staticStyle: {
                                                      cursor: "default",
                                                    },
                                                    style: {
                                                      color: "#008236",
                                                      "background-color":
                                                        "#f0fdf4",
                                                      "border-color": "#b9f8cf",
                                                    },
                                                  },
                                                  [_vm._v("Available")]
                                                )
                                              : data.item.Status == 1
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn-tertiary-full",
                                                    staticStyle: {
                                                      cursor: "default",
                                                    },
                                                  },
                                                  [_vm._v("Assigned")]
                                                )
                                              : _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn-tertiary-full",
                                                    staticStyle: {
                                                      cursor: "default",
                                                    },
                                                    style: {
                                                      color: "#c10007",
                                                      "background-color":
                                                        "#fef2f2",
                                                      "border-color": "#ffc9c9",
                                                    },
                                                  },
                                                  [_vm._v("Frozen")]
                                                ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(clientnumber)",
                                        fn: function (data) {
                                          return [
                                            data.item.Reference1 != ""
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(data.item.Reference1)
                                                  ),
                                                ])
                                              : _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "font-weight": "normal",
                                                    },
                                                  },
                                                  [_vm._v("—")]
                                                ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(allocationdate)",
                                        fn: function (data) {
                                          return [
                                            data.item.Date != ""
                                              ? _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      new Date(
                                                        Date.parse(
                                                          data.item.Date
                                                        )
                                                      ).toLocaleDateString("fr")
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            data.item.Date != ""
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#6a7282",
                                                      "font-size": "0.9rem",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        new Date(
                                                          Date.parse(
                                                            data.item.Date
                                                          )
                                                        ).toLocaleTimeString(
                                                          "it-IT"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _c("span", [_vm._v("—")]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(actions)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn-outline-light",
                                                attrs: {
                                                  id:
                                                    "view-transaction-btn-" +
                                                    data.index,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.navigate(
                                                      "/transactionledger/" +
                                                        data.item.VIBAN
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa-regular fa-eye",
                                                }),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-popover",
                                              {
                                                attrs: {
                                                  target:
                                                    "view-transaction-btn-" +
                                                    data.index,
                                                  triggers: "hover",
                                                  placement: "top",
                                                  "custom-class": "popover-btn",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  View transaction\n                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1127129425
                                  ),
                                }),
                                _vm._v(" "),
                                _c("hr"),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.totalResultsFiltered > 0
                          ? _c("b-row", { staticClass: "pagination" }, [
                              _c(
                                "button",
                                {
                                  class: [
                                    "btn-outline-light btn",
                                    { inactive: _vm.currentPage == 1 },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      _vm.currentPage > 1 && _vm.previous()
                                    },
                                  },
                                },
                                [_vm._v("Previous")]
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "Page " +
                                    _vm._s(_vm.currentPage) +
                                    " of " +
                                    _vm._s(_vm.totalPages)
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  class: [
                                    "btn-outline-light btn",
                                    {
                                      inactive:
                                        _vm.currentPage == _vm.totalPages,
                                    },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      _vm.currentPage < _vm.totalPages &&
                                        _vm.next()
                                    },
                                  },
                                },
                                [_vm._v("Next")]
                              ),
                            ])
                          : _c(
                              "div",
                              {
                                staticStyle: {
                                  margin: "1rem",
                                  color: "#969696",
                                  display: "flex",
                                  "justify-content": "center",
                                },
                              },
                              [_c("span", [_vm._v("No results found")])]
                            ),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "card empty" },
                      [_c("b-spinner", { attrs: { label: "Loading..." } })],
                      1
                    ),
              ],
              1
            ),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }